import { get } from 'svelte/store'
import { userStore, pageOptsStore } from '@packages/stores'
import { getAddress } from '@src/passport/blockchain'
import { configStore } from '@src/stores/config'
import { getClientConfigByClientId } from '@lib/clients'
import { processOrder, createOrder } from '../order.service'
import type { TBasicPaymentData } from '../oders.types'


export const processPayment = async (stripeTokenId: string) => {
  const config = get(configStore)
  const paymentOpts = get(pageOptsStore)
  const user = get(userStore)
  const userAddress = await getAddress()

  const email = user?.email || user?.pending?.email
  const phone = user?.phone || user?.pending?.phone
  const description =
    'Passport Payment: ' +
    `(${JSON.stringify({
      ...paymentOpts.tokens,
      ...paymentOpts.memberships,
      ...paymentOpts.licenses,
      userAddress,
      chainId: config.chainId,
      email,
      phone,
    })})`

  const clientName = getClientConfigByClientId(config.clientId).name
  const stripePK = config.stripe.pk[clientName] ?? config.stripe.pk.DEFAULT
  const basicPaymentData: TBasicPaymentData = {
    card_token: stripePK.includes('pk_live') ? stripeTokenId : 'tok_visa',
    client: clientName,
    description,
    address: userAddress,
    chain_id: Number(config.chainId),
    currency: 'USD',
  }

  const order = await createOrder(basicPaymentData)
  return await processOrder(order)
}
